import React from 'react';
import { motion } from 'framer-motion';
import Hero from './components/Hero';
import ReviewSection from './components/ReviewSection';
import TrustSection from './components/TrustSection';
import ProcessSection from './components/ProcessSection';
import BenefitsSection from './components/BenefitsSection';
import CoverageSection from './components/CoverageSection';
import CoteriePartnership from './components/CoteriePartnership';
import ApplicationGuide from './components/ApplicationGuide';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import FloatingInfoWidget from './components/FloatingInfoWidget';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <Hero />
      <ReviewSection />
      <TrustSection />
      <ProcessSection />
      <BenefitsSection />
      <CoverageSection />
      <CoteriePartnership />
      <ApplicationGuide />
      <FinalCTA />
      <Footer />
      <FloatingInfoWidget />
    </div>
  );
}

export default App;